import { render, staticRenderFns } from "./failed.vue?vue&type=template&id=65761dec&scoped=true"
import script from "./failed.vue?vue&type=script&setup=true&lang=js"
export * from "./failed.vue?vue&type=script&setup=true&lang=js"
import style0 from "./failed.vue?vue&type=style&index=0&id=65761dec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65761dec",
  null
  
)

export default component.exports